import ScrollablePanelCSS from './scrollable-panel-css.js';


export default function ScrollablePanel (model, args)
{
  const css = new ScrollablePanelCSS();

  const initFireScrollTimeOut = 50,
        initScrollDirection = { Down: 'Down', Up: 'Up' },
        initScrollSpeed = { Fast: 10, Slow: 2 },
        initZIndex = { ScrollBarContainer: 3, ScrollBarSlider: 5 };

  let initCustomScrollBarWidth = 0;

  let pThis = this,
      parentComponent = args.parentComponent,
      win = args.window || window,
      parentContainer = args.parentContainer || null,
      containerWidth = (typeof(args.containerWidth) === 'number') ? args.containerWidth : null,
      containerHeight = (typeof(args.containerHeight) === 'number') ? args.containerHeight : null,
      isBorder = args.isBorder || false,
      isNoRightPadding = args.isNoRightPadding || false,
      isOuterSlider = args.isOuterSlider || false,
      isResizable = args.isResizable || false;

  if (args.scrollBarContainerZIndex != null)
  {
    initZIndex.ScrollBarContainer = args.scrollBarContainerZIndex;
  }

  if (args.scrollBarSliderZIndex != null)
  {
    initZIndex.ScrollBarSlider = args.scrollBarSliderZIndex;
  }

  pThis.RenderComplete = BEditor.eventHandlers.createHandlers(pThis, { id: 'RenderComplete' });
  pThis.Dispose = BEditor.eventHandlers.createHandlers(pThis, { id: 'Dispose' });

  pThis.ScrollablePanelShown = BEditor.eventHandlers.createHandlers(pThis, { id: 'ScrollablePanelShown' });
  pThis.ScrollablePanelHidden = BEditor.eventHandlers.createHandlers(pThis, { id: 'ScrollablePanelHidden' });
  pThis.ScrollablePanelScroll = BEditor.eventHandlers.createHandlers(pThis, { id: 'ScrollablePanelScroll' });

  let container,
      structure,
      isBarMoveOrDrag = false,
      mouseY,
      barMoveCounter,
      scrollerY,
      contentScrollTop,
      autoScrollSpeed = initScrollSpeed.Slow,
      autoScrollDirection = initScrollDirection.Down,
      autoScrollEnabled = false,
      autoScrollTimeout = 32,
      minSliderHeight = 20,
      currentScrollTop,
      isScrollVisible = false,
      autoScrollTM = null,
      calculateTM = null,
      fireOnScrollTM = null,
      barMoveTM = null,
      barMoveStopTM = null,
      barDragStopTM = null;

  pThis.init = init;
  pThis.render = render;
  pThis.calculate = calculate;
  pThis.setDimensions = setDimensions;
  pThis.resetDimensions = resetDimensions;
  pThis.startAutoScroll = startAutoScroll;
  pThis.stopAutoScroll = stopAutoScroll;
  pThis.setContent = setContent;
  pThis.getContainerRect = function () { return BEditor.dimensions.getElementRect(container); };
  pThis.isSliderMoving = function () { return isBarMoveOrDrag; };


  function setContent(content)
  {
    container.innerHTML = content;
  }


  function stopAutoScroll()
  {
    autoScrollEnabled = false;
    if (autoScrollTM) clearTimeout(autoScrollTM);
  }


  function startAutoScroll(args)
  {
    autoScrollDirection = args.scrollDirection;
    autoScrollSpeed = args.scrollSpeed;
    autoScrollEnabled = true;

    currentScrollTop = structure.parseTags.editorScrollablePanelContentContainer[0].scrollTop;

    if (autoScrollTM) clearTimeout(autoScrollTM);
    autoScrollTM = setTimeout(doAutoScroll, autoScrollTimeout);
  }


  function doAutoScroll()
  {
    if (!autoScrollEnabled)
    {
      if (autoScrollTM) clearTimeout(autoScrollTM);
      return;
    }


    switch (autoScrollDirection)
    {
      case initScrollDirection.Up:
      {
        currentScrollTop -= autoScrollSpeed;

        if (currentScrollTop < 0)
        {
          currentScrollTop = 0;
          stopAutoScroll();
        }
        break;
      }

      case initScrollDirection.Down:
      {
        currentScrollTop += autoScrollSpeed;
        break;
      }
    }

    structure.parseTags.editorScrollablePanelContentContainer[0].scrollTop = currentScrollTop;

    if (autoScrollTM) clearTimeout(autoScrollTM);
    autoScrollTM = setTimeout(doAutoScroll, autoScrollTimeout);
  }


  function render()
  {
    if (model.isBorder === null)
    {
      model.isBorder = isBorder;
    }

    return scrollablePanelTemplate();
  }


  function setDimensions(dimentions)
  {
    dimentions = dimentions || {};

    if (dimentions.height !== undefined)
    {
      containerHeight = dimentions.height;
    }

    if (dimentions.width !== undefined)
    {
      containerWidth = dimentions.width;
    }

    preCalculate();
    calculate();
  }


  function resetDimensions()
  {
    structure.parseTags.editorScrollablePanelWrapper[0].style.width = '';
    structure.parseTags.editorScrollablePanelWrapper[0].style.height = '';
    structure.parseTags.editorScrollablePanelContentContainer[0].style.width = '';
    structure.parseTags.editorScrollablePanelContentContainer[0].style.height = '';
  }


  function stopMouseWheel(e)
  {
    if (isScrollVisible)
    {
      BEditor.domHandlers.stopEventBubbling(e);
    }
  }


  function onRenderComplete (sender, args)
  {
    container = BEditor.domHelpers.$(model.id + '_ScrollablePanelContainer', win);
    structure = BEditor.domHelpers.parseHTML(container);

    preCalculate();
    calculate();

    BEditor.domHandlers.addHandler(structure.parseTags.editorScrollBarContainer[0], 'mousedown', barMoveStart, win);

    BEditor.domHandlers.addHandlers(
      [
        [win, 'resize', recalculate],
        [structure.parseTags.editorScrollablePanelContentContainer[0],
          [
            ['scroll', updateScrollBar],
            ['mousewheel', stopMouseWheel]
          ]],
        [structure.parseTags.editorScrollBarContainer[0],
          [
            //['mousedown', barMoveStart],
            ['mousewheel', createWheelEvent]
          ]],
        [structure.parseTags.editorScrollBarSlider[0],
          [
            ['mouseover', mouseOver],
            ['mouseout', mouseOut],
            ['mousedown', barDragStart]
          ]]
      ]);

    if (parentComponent.RecalculatedSize)
    {
      parentComponent.RecalculatedSize.addHandler(recalculate);
    }

    pThis.RenderComplete.fireHandlers();
  }


  function preCalculate()
  {
    if (containerWidth !== null)
    {
      structure.parseTags.editorScrollablePanelContentContainer[0].style.width = containerWidth + 'px';
    }

    if (containerHeight !== null)
    {
      structure.parseTags.editorScrollablePanelContentContainer[0].style.height = containerHeight + 'px';
    }
  }


  function calculate ()
  {
    if (!initCustomScrollBarWidth)
    {
      initCustomScrollBarWidth = structure.parseTags.editorScrollBarContainer[0].offsetWidth;
    }

    let containerSize = BEditor.dimensions.getElementBox(container),
        contentContainerSize = BEditor.dimensions.getElementBox(structure.parseTags.editorScrollablePanelContentContainer[0]),
        systemScrollBarWidth = BEditor.browser.isWebKit ? 0 : BEditor.window.getScrollBarWidth(),
        customScrollBarWidth = initCustomScrollBarWidth,
        contentContainerWidth = containerSize.innerOffsetWidth  + systemScrollBarWidth,
        contentContainerHeight = contentContainerSize.offsetHeight,
        scrollBarContainerHeight = contentContainerHeight + containerSize.borderTopWidth + containerSize.borderBottomWidth,
        sliderHeight = Math.floor(scrollBarContainerHeight / ((contentContainerSize.scrollHeight / (contentContainerHeight || 1)) || 1)),
        scrollablePanelContentContainerWidth = contentContainerWidth - contentContainerSize.deltaInnerWidth,
        scrollablePanelWrapperWidth = contentContainerWidth - systemScrollBarWidth;
        scrollablePanelContentContainerWidth = (scrollablePanelContentContainerWidth < 0) ? 0 : scrollablePanelContentContainerWidth;
        scrollablePanelWrapperWidth = (scrollablePanelWrapperWidth < 0) ? 0 : scrollablePanelWrapperWidth;
        contentContainerHeight = (contentContainerHeight < 0) ? 0 : contentContainerHeight;
        scrollBarContainerHeight = (scrollBarContainerHeight < 0) ? 0 : scrollBarContainerHeight;
        sliderHeight = (sliderHeight < minSliderHeight) ? minSliderHeight : sliderHeight;

    structure.parseTags.editorScrollablePanelContentContainer[0].style.width = scrollablePanelContentContainerWidth + 'px';

    structure.parseTags.editorScrollablePanelWrapper[0].style.width = scrollablePanelWrapperWidth + 'px';
    structure.parseTags.editorScrollablePanelWrapper[0].style.height = contentContainerHeight + 'px';

    structure.parseTags.editorScrollBarContainer[0].style.top = (-containerSize.borderTopWidth) + 'px';
    structure.parseTags.editorScrollBarContainer[0].style.right = (isOuterSlider ? -customScrollBarWidth : -containerSize.borderRightWidth) + 'px';
    structure.parseTags.editorScrollBarContainer[0].style.height = scrollBarContainerHeight + 'px';
    structure.parseTags.editorScrollBarContainer[0].style.zIndex = initZIndex.ScrollBarContainer;
    structure.parseTags.editorScrollBarSlider[0].style.height = sliderHeight + 'px';
    structure.parseTags.editorScrollBarSlider[0].style.zIndex = initZIndex.ScrollBarSlider;

    structure.parseTags.editorScrollablePanelContentContainer[0].style.visibility = 'visible';

    if (contentContainerSize.scrollHeight > contentContainerHeight + 1)
    {
      isScrollVisible = true;
      structure.parseTags.editorScrollBarContainer[0].style.visibility = 'visible';
      BEditor.domHelpers.addClassName(structure.parseTags.editorScrollablePanelWrapper[0], 'scrollVisible');
      pThis.ScrollablePanelShown.fireHandlers({ width: scrollablePanelWrapperWidth, scrollBarWidth: customScrollBarWidth });
    }
    else
    {
      isScrollVisible = false;

      if (isNoRightPadding)
      {
        structure.parseTags.editorScrollablePanelContentContainer[0].style.width = (scrollablePanelContentContainerWidth + customScrollBarWidth - containerSize.borderRightWidth) + 'px';
        structure.parseTags.editorScrollablePanelWrapper[0].style.width = (scrollablePanelWrapperWidth + customScrollBarWidth - containerSize.borderRightWidth) + 'px';
      }

      structure.parseTags.editorScrollBarContainer[0].style.visibility = 'hidden';
      BEditor.domHelpers.removeClassName(structure.parseTags.editorScrollablePanelWrapper[0], 'scrollVisible');
      pThis.ScrollablePanelHidden.fireHandlers();
    }

    updateScrollBar(scrollBarContainerHeight);
  }


  function recalculate ()
  {
    structure.parseTags.editorScrollablePanelContentContainer[0].style.width = 'auto';
    if (calculateTM) clearTimeout(calculateTM);
    calculateTM = setTimeout(calculate, 17);
  }


  function mouseOver ()
  {
    if (!isBarMoveOrDrag && !BEditor.domHelpers.containsClassName(structure.parseTags.editorScrollBarContainer[0], 'editorScrollBarContainerOver'))
    {
      structure.parseTags.editorScrollBarContainer[0].className = 'editorScrollBarContainer editorScrollBarContainerOver';
    }
  }


  function mouseOut ()
  {
    if (!isBarMoveOrDrag && !BEditor.domHelpers.containsClassName(structure.parseTags.editorScrollBarContainer[0], 'editorScrollBarContainerNormal'))
    {
      structure.parseTags.editorScrollBarContainer[0].className = 'editorScrollBarContainer editorScrollBarContainerNormal';
    }
  }


  function barActive()
  {
    if (!BEditor.domHelpers.containsClassName(structure.parseTags.editorScrollBarContainer[0], 'editorScrollBarContainerActive'))
    {
      structure.parseTags.editorScrollBarContainer[0].className = 'editorScrollBarContainer editorScrollBarContainerActive';
    }
  }


  function updateScrollBar(scrollBarContainerHeight)
  {
    contentScrollTop = structure.parseTags.editorScrollablePanelContentContainer[0].scrollTop;
    scrollBarContainerHeight = (typeof(scrollBarContainerHeight) === 'number') ? scrollBarContainerHeight : structure.parseTags.editorScrollBarContainer[0].offsetHeight;

    let scrollTop = Math.round(contentScrollTop / ((structure.parseTags.editorScrollablePanelContentContainer[0].scrollHeight / (scrollBarContainerHeight || 1)) || 1)),
        scrollBarSliderHeight;

    if (scrollTop < 1)
    {
      scrollTop = 1;
    }
    else
    {
      scrollBarSliderHeight = structure.parseTags.editorScrollBarSlider[0].offsetHeight;

      if (scrollTop + scrollBarSliderHeight > scrollBarContainerHeight)
      {
        scrollTop = scrollBarContainerHeight - scrollBarSliderHeight;
      }
    }

    structure.parseTags.editorScrollBarSlider[0].style.top = scrollTop + 'px';
    if (fireOnScrollTM) clearTimeout(fireOnScrollTM);
    fireOnScrollTM = setTimeout(fireOnScroll, initFireScrollTimeOut);
  }


  function fireOnScroll()
  {
    pThis.ScrollablePanelScroll.fireHandlers({ contentScrollTop: contentScrollTop });
  }


  function createWheelEvent (e)
  {
    e = e || event;

    let myEvent;

    if (e)
    {
      try
      {
        myEvent = document.createEvent('WheelEvent');
        myEvent.initWebKitWheelEvent(e.wheelDeltaX, e.wheelDeltaY);
        structure.parseTags.editorScrollablePanelContentContainer[0].dispatchEvent(myEvent);
        return BEditor.domHandlers.stopEvent(e);
      }
      catch (err) {}
    }
  }


  function barMoveStart (e)
  {
    if (!(e = e || event) || !(e.button === 0 || e.button === 1))
    {
      return;
    }

    isBarMoveOrDrag = true;
    barActive();
    barMoveCounter = 0;
    mouseY = e.clientY;
    barMove();

    BEditor.domHandlers.addHandlers(
      [
        [win.document,
          [
            ['mousemove', barMove],
            ['mouseup', barMoveStop]
          ]]
      ]);

    BEditor.domHandlers.stopEvent(e);
  }


  function barMove ()
  {
    const coords = BEditor.dimensions.getElementScreenXY(structure.parseTags.editorScrollBarSlider[0]);

    if (mouseY < coords.Y || mouseY > coords.Y + coords.height)
    {
      structure.parseTags.editorScrollablePanelContentContainer[0].scrollTop += (mouseY < coords.Y ? -1 : 1) * structure.parseTags.editorScrollablePanelContentContainer[0].offsetHeight;
      updateScrollBar();
    }

    barMoveCounter++;
    if (barMoveTM) clearTimeout(barMoveTM);
    barMoveTM = setTimeout(barMove, (Math.round(373 / barMoveCounter) >= 17 ? Math.round(373 / barMoveCounter) : 17));
  }


  function barMoveOut ()
  {
    if (barMoveStopTM) clearTimeout(barMoveStopTM);
    barMoveStopTM = setTimeout(barMoveStop, 137);
  }


  function barMoveOver ()
  {
    if (barMoveStopTM) clearTimeout(barMoveStopTM);
  }


  function barMoveStop ()
  {
    if (barMoveTM) clearTimeout(barMoveTM);
    if (barMoveStopTM) clearTimeout(barMoveStopTM);

    BEditor.domHandlers.removeHandlers(
      [
        [win.document,
          [
            ['mousemove', barMove],
            ['mouseup', barMoveStop]
          ]]
      ]);

    mouseOver();
    isBarMoveOrDrag = false;
  }


  function barDragStart (e)
  {
    if (!(e = e || event) || !(e.button === 0 || e.button === 1))
    {
      return;
    }

    isBarMoveOrDrag = true;
    barActive();
    scrollerY = e.screenY;

    BEditor.domHandlers.addHandlers(
      [
        [win.document,
          [
            ['selectstart', textSelectOff]
          ]]
      ]);

    BEditor.globalHandlers.addGlobalHandler((BEditor.browser.isIE ? 'body' : 'window'), 'mouseup', barDragStop, 'ScrollablePanelBarDragStop', {});
    BEditor.globalHandlers.addGlobalHandler((BEditor.browser.isIE ? 'body' : 'window'), 'mousemove', barDrag, 'ScrollablePanelBarDrag', {});

    BEditor.domHandlers.stopEvent(e);
  }


  function barDrag (e)
  {
    if (!(e = e || event))
    {
      return;
    }

    structure.parseTags.editorScrollablePanelContentContainer[0].scrollTop += Math.floor((e.screenY - scrollerY) * (structure.parseTags.editorScrollablePanelContentContainer[0].scrollHeight / structure.parseTags.editorScrollablePanelContentContainer[0].offsetHeight));
    scrollerY = e.screenY;

    BEditor.domHandlers.stopEvent(e);
  }


  function barDragOut ()
  {
    if (barDragStopTM) clearTimeout(barDragStopTM);
    barDragStopTM = setTimeout(barDragStop, 137);
  }


  function barDragOver ()
  {
    if (barDragStopTM) clearTimeout(barDragStopTM);
  }


  function barDragStop ()
  {
    if (barDragStopTM) clearTimeout(barDragStopTM);

    BEditor.domHandlers.removeHandlers(
      [
        [win.document,
          [
            ['selectstart', textSelectOff]
          ]]
      ]);

    BEditor.globalHandlers.removeGlobalHandler('ScrollablePanelBarDragStop');
    BEditor.globalHandlers.removeGlobalHandler('ScrollablePanelBarDrag');

    mouseOver();
    isBarMoveOrDrag = false;
  }


  function textSelectOff ()
  {
    return false;
  }


  function clearAllThrottle()
  {
    if (autoScrollTM) clearTimeout(autoScrollTM);
    if (calculateTM) clearTimeout(calculateTM);
    if (barMoveTM) clearTimeout(barMoveTM);
    if (barMoveStopTM) clearTimeout(barMoveStopTM);
    if (barDragStopTM) clearTimeout(barDragStopTM);
    if (fireOnScrollTM) clearTimeout(fireOnScrollTM);
  }


  function onVisualStateChanged(sender, args)
  {
    recalculate();
  }


  function init()
  {
    css.create(win);

    if (parentContainer)
    {
      parentContainer.innerHTML = render();
    }

    onRenderComplete();

    //parentComponent.RenderComplete.addHandler(onRenderComplete);
    //parentComponent.Dispose.addHandler(dispose);
  }


  this.destructor = () =>
  {
    clearAllThrottle();

    this.Dispose.fireHandlers();

    //parentComponent.RenderComplete.removeHandler(onRenderComplete);
    //parentComponent.Dispose.removeHandler(dispose);

    model = null;
    parentComponent = null;

    //pThis.RenderComplete = null;
    //pThis.Dispose = null;

    BEditor.domHandlers.removeHandlers(
      [
        [window, 'resize', recalculate],
        [(structure ? structure.parseTags.editorScrollablePanelContentContainer[0] : null),
          [
            ['scroll', updateScrollBar],
            ['mousewheel', stopMouseWheel]
          ]],
        [(structure ? structure.parseTags.editorScrollBarContainer[0] : null),
          [
            ['mousedown', barMoveStart],
            ['mousewheel', createWheelEvent]
          ]],
        [(structure ? structure.parseTags.editorScrollBarSlider[0] : null),
          [
            ['mouseover', mouseOver],
            ['mouseout', mouseOut],
            ['mousedown', barDragStart]
          ]],
        [win.document,
          [
            ['mousemove', barMove],
            ['mouseup', barMoveStop],
            ['selectstart', textSelectOff]
          ]]
      ]);

    container = null;
    structure = null;
    barMoveCounter = null;
    contentScrollTop = null;

    BEditor.globalHandlers.removeGlobalHandler('ScrollablePanelBarDragStop');
    BEditor.globalHandlers.removeGlobalHandler('ScrollablePanelBarDrag');

    pThis.ScrollablePanelShown = null;
    pThis.ScrollablePanelHidden = null;
    pThis.ScrollablePanelScroll = null;
  }


  function scrollablePanelTemplate ()
  {
    return `<div id="${model.id}_ScrollablePanelContainer" class="editorScrollablePanelContainer${(model.isBorder ? ' editorScrollablePanelContainerBorder' : '') + (model.cssClass ? ' ' + model.cssClass + '_ScrollablePanelContainer' : '')}">
              <div class="editorScrollablePanelWrapper" parseTags="editorScrollablePanelWrapper">
                <div class="editorScrollablePanelContentContainer" parseTags="editorScrollablePanelContentContainer" style="${(model.containerHeight != null ? 'height: ' + model.containerHeight + 'px;' : '') + (model.containerMaxHeight != null ? 'max-height: ' + model.containerMaxHeight + 'px;' : '')}">
                  <div id="${model.id}" class="editorScrollablePanelContent${model.cssClass ? ` ${model.cssClass}` : ''}" parseTags="editorScrollablePanelContent${model.parseTags ? ` ${model.parseTags}` : ''}">${model.contentHTML}</div>
                </div>
              </div>
              <div class="editorScrollBarContainer editorScrollBarContainerNormal" parseTags="editorScrollBarContainer">
                <div class="editorScrollBarTop"></div>
                <div class="editorScrollBarBottom"></div>
                <div class="editorScrollBarSlider" parseTags="editorScrollBarSlider">
                  <div class="editorScrollBarSliderTop"></div>
                  <div class="editorScrollBarSliderMiddle" parseTags="editorScrollBarSliderMiddle"></div>
                  <div class="editorScrollBarSliderBottom"></div>
                </div>
              </div>
            </div>`;
  }


  init();
}